import React from 'react';
import { colors } from '@/globalStyles';
import { arcPointsToSvgPath } from '../../../helpers/calculation';

const ArcComponent = props => {
  const { id, primitiveProps, style, className } = props;
  const { start_point, point_on_the_arc, end_point, outline_style } = primitiveProps;
  const pathVal = arcPointsToSvgPath(start_point, point_on_the_arc, end_point);
  const parsedStyle = JSON.parse(JSON.stringify(style));
  const styles = {
    ...parsedStyle,
    pointerEvents: className === 'decoration' ? 'none' : 'unset',
    fill: 'none',
    ...(!parsedStyle.stroke && { stroke: outline_style && outline_style.enabled && outline_style.color ? outline_style.color : colors.black }),
  };
 
  return <path id={id} d={pathVal} className={className} style={styles} />;
};

export default ArcComponent;
